import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

export function compareParentNodes(node, comparisonNode) {
  while (node.parentNode) {
    if (node === comparisonNode) return true;
    node = node.parentNode;
  }

  return false;
}
export function getElementOffset(el) {
  var rect = el.getBoundingClientRect();
  var docEl = document.documentElement;
  var rectTop = rect.top + window.pageYOffset - docEl.clientTop;
  var rectLeft = rect.left + window.pageXOffset - docEl.clientLeft;
  return {
    top: rectTop,
    left: rectLeft
  };
}
export function getClientPos(e) {
  var pageX;
  var pageY;

  if (e.touches) {
    pageX = e.touches[0].pageX;
    pageY = e.touches[0].pageY;
  } else {
    pageX = e.pageX;
    pageY = e.pageY;
  }

  return {
    x: pageX,
    y: pageY
  };
}
export function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}
export function isCropValid(crop) {
  return crop && crop.width && crop.height;
}
export function inverseOrd(ord) {
  var inversedOrd;
  if (ord === 'n') inversedOrd = 's';else if (ord === 'ne') inversedOrd = 'sw';else if (ord === 'e') inversedOrd = 'w';else if (ord === 'se') inversedOrd = 'nw';else if (ord === 's') inversedOrd = 'n';else if (ord === 'sw') inversedOrd = 'ne';else if (ord === 'w') inversedOrd = 'e';else if (ord === 'nw') inversedOrd = 'se';
  return inversedOrd;
}
export function makeAspectCrop(crop, drawSurfaceAspect) {
  var completeCrop = _objectSpread({}, crop);

  if (crop.width) {
    completeCrop.height = crop.width / crop.aspect * drawSurfaceAspect;
  }

  if (crop.height) {
    completeCrop.width = (completeCrop.height || crop.height) * (crop.aspect / drawSurfaceAspect);
  }

  if (crop.y + (completeCrop.height || crop.height) > 100) {
    completeCrop.height = 100 - crop.y;
    completeCrop.width = completeCrop.height * crop.aspect / drawSurfaceAspect;
  }

  if (crop.x + (completeCrop.width || crop.width) > 100) {
    completeCrop.width = 100 - crop.x;
    completeCrop.height = completeCrop.width / crop.aspect * drawSurfaceAspect;
  }

  return completeCrop;
}
export function containCrop(crop, drawSurfaceAspect) {
  var contained = _objectSpread({}, crop); // Don't let the crop grow on the opposite side when hitting an x image boundary.


  var cropXAdjusted = false;

  if (contained.x + contained.width > 100) {
    contained.width = crop.width + (100 - (crop.x + crop.width));
    contained.x = crop.x + (100 - (crop.x + contained.width));
    cropXAdjusted = true;
  } else if (contained.x < 0) {
    contained.width = crop.x + crop.width;
    contained.x = 0;
    cropXAdjusted = true;
  }

  if (cropXAdjusted && crop.aspect) {
    // Adjust height to the resized width to maintain aspect.
    contained.height = contained.width / crop.aspect * drawSurfaceAspect; // If sizing in up direction we need to pin Y at the point it
    // would be at the boundary.

    if (contained.y < crop.y) {
      contained.y = crop.y + (crop.height - contained.height);
    }
  } // Don't let the crop grow on the opposite side when hitting a y image boundary.


  var cropYAdjusted = false;

  if (contained.y + contained.height > 100) {
    contained.height = crop.height + (100 - (crop.y + crop.height));
    contained.y = crop.y + (100 - (crop.y + contained.height));
    cropYAdjusted = true;
  } else if (contained.y < 0) {
    contained.height = crop.y + crop.height;
    contained.y = 0;
    cropYAdjusted = true;
  }

  if (cropYAdjusted && crop.aspect) {
    // Adjust width to the resized height to maintain aspect.
    contained.width = contained.height * crop.aspect / drawSurfaceAspect; // If sizing in up direction we need to pin X at the point it
    // would be at the boundary.

    if (contained.x < crop.x) {
      contained.x = crop.x + (crop.width - contained.width);
    }
  }

  return contained;
}
/**
 * @param {String} imageSrc - Path to image
 * @param {File} imageFile - File containing the image
 * @param {Object} pixelCrop - pixelCrop Object provided by CropSelector
 * @param {String} fileName - Name of the returned file in Promise
 * @param {Boolean} base64 - Whether to return the image in base64 format
 * @param {Float} quality - Quality of the jpeg image returned - can be between 0 and 1
 * @param {String|null} crossOrigin - Indicates if fetching the image requires CORS, options are: 'anonymous', 'use-credentials' or null
 *
 * For more info on the impact CORS can have on images and canvases please see:
 * https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
 */

export function getCroppedImage(_ref) {
  var imageSrc = _ref.imageSrc,
      imageFile = _ref.imageFile,
      pixelCrop = _ref.pixelCrop,
      fileName = _ref.fileName,
      _ref$base = _ref.base64,
      base64 = _ref$base === void 0 ? true : _ref$base,
      _ref$quality = _ref.quality,
      quality = _ref$quality === void 0 ? 1 : _ref$quality,
      _ref$crossOrigin = _ref.crossOrigin,
      crossOrigin = _ref$crossOrigin === void 0 ? null : _ref$crossOrigin;
  return new _Promise(function (resolve, reject) {
    var getImage = function getImage(image) {
      var canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height);

      if (base64) {
        // As Base64 string
        try {
          var base64Image = canvas.toDataURL('image/jpeg', quality);
          resolve(base64Image);
        } catch (e) {
          reject(e);
        }
      } else {
        // As a blob
        try {
          canvas.toBlob(function (file) {
            file.name = fileName;
            resolve(file);
          }, 'image/jpeg');
        } catch (e) {
          reject(e);
        }
      }
    };

    if (imageSrc) {
      var fakeImage = new Image();

      fakeImage.onload = function () {
        try {
          getImage(this);
        } catch (e) {
          reject(e);
        }
      };

      fakeImage.onerror = reject;
      fakeImage.crossOrigin = crossOrigin;
      fakeImage.src = imageSrc;
    } else if (imageFile) {
      try {
        getImage(imageFile);
      } catch (e) {
        reject(e);
      }
    } else {
      reject(new Error('Must supply either the imageSrc or imageFile parameter.'));
    }
  });
}
export function base64Empty(base64) {
  return base64.split('data:,')[1] === '';
}